<template>
    <div class="page"
         v-loading.fullscreen.lock="fullscreenLoading"
         element-loading-text="加载中"
         element-loading-spinner="el-icon-loading"
         element-loading-background="rgba(0, 0, 0, 0.5)">
        <!-- 搜索 -->
        <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="100px" :inline="true" size="small"
                 class="query-form" @submit.native.prevent>
            <el-form-item label="所属账号">
                <GridSelectU style="width: 200px;" title="选择所属账号" labelName="userName"
                             labelValue="id" :value="queryForm.userId" :limit='1' size='small'
                             placeholder='请选择所属账号'
                             @getValue="getSearchValueUser" :columns="USER_code" :searchs="USER_search"
                             dataListUrl="/mpp/user/findList" entityBeanName="mppUser"
                             queryEntityUrl="/mpp/user/get">
                </GridSelectU>
            </el-form-item>
            <el-form-item label="子商户号">
                <el-input v-model="queryForm.subAccount" style="width: 200px;"></el-input>
            </el-form-item>
            <el-form-item label="组织类型">
                <el-select v-model="queryForm.orgType" style="width: 200px;">
                    <el-option v-for="(item,index) in storeOrgTypeStatusEunmList" :key="index" :value="item.key" :label="item.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="营业执照名称">
                <el-input v-model="queryForm.licenseName" style="width: 200px;"></el-input>
            </el-form-item>
            <el-form-item label="法人姓名">
                <el-input v-model="queryForm.personName" style="width: 200px;"></el-input>
            </el-form-item>
            <el-form-item
                label="银盛支付审核状态"
                prop="thirdStatus"
            >
                <el-select
                    v-model="queryForm.thirdStatus"
                    size="small"
                    placeholder="请选择支付审核状态"
                    clearable
                    style="width: 200px"
                >
                    <el-option v-for="(item,index) in auditStatusEnumList" :label="item.value" :value="item.key"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item
                label="微信支付审核状态"
                prop="wxpayStatus"
            >
                <el-select
                    v-model="queryForm.wxpayStatus"
                    size="small"
                    placeholder="请选择微信支付认证状态"
                    clearable
                    style="width: 200px"
                >
                    <el-option label="未认证" :value="0"> </el-option>
                    <el-option label="已认证" :value="1"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item
                label="支付宝支付认证状态"
                prop="alipayStatus"
            >
                <el-select
                    v-model="queryForm.alipayStatus"
                    size="small"
                    placeholder="请选择支付宝支付审核状态"
                    clearable
                    style="width: 200px"
                >
                    <el-option label="未认证" :value="0"> </el-option>
                    <el-option label="已认证" :value="1"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="是否签约">
                <el-select v-model="queryForm.isSign" style="width: 200px;">
                    <el-option v-for="(item,index) in yesNoEunmList" :key="index" :value="item.key" :label="item.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="getShopStoreOrgInfoList">查询
                </el-button>
                <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
            </el-form-item>
        </el-form>
        <div class="page-content">
            <div class="page-tool-bar">
                <div class="el-btn-group">
<!--                    <el-button-->
<!--                        type="primary"-->
<!--                        size="small"-->
<!--                        icon="el-icon-plus"-->
<!--                        @click="addShopStoreOrgInfo"-->
<!--                    >新建-->
<!--                    </el-button>-->
                    <el-button
                        type="warning"
                        plain
                        size="small"
                        icon="el-icon-edit"
                        :disabled="multipleSelection.length != 1"
                        @click="editShopStoreOrgInfo(null)"
                    >修改
                    </el-button>
<!--                    <el-button-->
<!--                        type="danger"-->
<!--                        plain-->
<!--                        size="small"-->
<!--                        icon="el-icon-delete"-->
<!--                        :disabled="multipleSelection.length <= 0"-->
<!--                        @click="deleteShopStoreOrgInfo(null)"-->
<!--                    >删除-->
<!--                    </el-button>-->
                </div>

                <div class="icon-group">
                    <el-upload v-if="this.isImportDate"
                               class="upload-demo"
                               action="#"
                               :http-request="upload"
                               :show-file-list="true">
                        <el-button size="small" type="primary">点击上传</el-button>
                        <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
                    </el-upload>
                    <span
                        title="搜索"
                        class="icon-box"
                        @click="search"
                    >
                        <Icon color="#606266">
                            <Search />
                        </Icon>
                    </span>
                    <span
                        class="icon-box"
                        @click="refreshShopStoreOrgInfoList"
                    >
                        <Icon color="#606266">
                            <Refresh />
                        </Icon>
                    </span>
                </div>
            </div>
            <!-- 列表数据 -->
            <el-table
                :data="shopStoreOrginfoList"
                row-key="id"
                border
                height="100%"
                :header-row-style="{height: '10px'}"
                :header-cell-style="{padding: '10px'}"
                :row-style="{height: '9px'}"
                :cell-style="{padding: '9px'}"
                @selection-change="handleSelectionChange"
                size="small"
            >
                <el-table-column
                    align="center"
                    type="selection"
                    width="60"
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="orgType"
                    label="组织类型"
                    width="140"
                >
                    <template scope="scope">
                        <div v-if="storeOrgTypeStatusEunmList && scope.row.orgType">
                            <el-tag size="small" type="danger" v-if="scope.row.orgType == 3">{{storeOrgTypeStatusEunmList.find(item=>item.key == scope.row.orgType).value}}</el-tag>
                            <el-tag size="small" v-else>{{storeOrgTypeStatusEunmList.find(item=>item.key == scope.row.orgType).value}}</el-tag>
                        </div>
                        <div v-else>-</div>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="storeId"
                    label="门店信息"
                    width="240"
                >
                    <template slot-scope="scope">
                        <div v-if="scope.row.store">
                            <div style="text-align: left">店名：{{scope.row.store.storeName}}</div>
                            <div style="text-align: left">时间：{{scope.row.store.openHours}}</div>
                            <div style="text-align: left">地址：{{scope.row.store.storeAddress}}</div>
                        </div>
                        <div v-else>暂无关联店铺</div>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="userId"
                    label="用户信息"
                    width="240"
                >
                    <template scope="scope">
                        <div v-if="scope.row.user">
                            <div style="text-align: left">账号：{{ scope.row.user.userName }}</div>
                            <div style="text-align: left">手机：{{ scope.row.user.userMobile }}</div>
                            <div style="text-align: left">昵称：{{ scope.row.user.userNickname }}</div>
                        </div>
                        <div v-else>暂无关联用户</div>
                    </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center"  label="审核状态" width="200">
                    <template slot-scope="scope">

                        <div style="text-align: left">银盛支付审核状态：<span :class="{'active': scope.row.thirdStatus == 2}">{{computeAuditStatus(scope.row.thirdStatus) }}</span></div>
                        <div style="text-align: left">微信支付认证状态：<span :class="{'active': scope.row.wxpayStatus}">{{ scope.row.wxpayStatus == 1 ? '已认证' : '未认证' }}</span></div>
                        <div style="text-align: left">支付宝支付认证状态：<span :class="{'active': scope.row.alipayStatus}">{{ scope.row.alipayStatus == 1 ? '已认证' : '未认证' }}</span></div>
                    </template>
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="resultMsg"
                    label="响应报文"
                    width="180"
                ></el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" label="审核失败原因" width="170">
                    <template slot-scope="scope">
                        <div v-if="scope.row.store.status == 3">
                            <span>{{scope.row.store.refuseReason}}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="personName"
                    label="法人信息"
                    width="240"
                >
                    <template scope="scope">
                        <div>
                            <div style="text-align: left">法人：{{scope.row.personName}}</div>
                            <div style="text-align: left">证号：{{scope.row.idCard}}</div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="bankAccount"
                    label="开户行信息"
                    width="240"
                >
                    <template scope="scope">
                        <div>
                            <div style="text-align: left">行别：{{scope.row.bankName}}</div>
                            <div style="text-align: left">户名：{{scope.row.bankHolder}}</div>
                            <div style="text-align: left">账号：{{scope.row.bankAccount}}</div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="idCardFacade"
                    label="身份证正面图片"
                    width="130"
                >
                    <template slot-scope="scope">
                        <div v-if='scope.row.idCardFacade'>
                            <el-image
                                @click='updateSrcList(scope.row.idCardFacade)'
                                style="width: 60px; height: 60px"
                                :src="scope.row.idCardFacade"
                                :preview-src-list="srcList"> </el-image>
                        </div>
                        <div v-else>-</div>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="idCardBack"
                    label="身份证背面图片"
                    width="130"
                >
                    <template slot-scope="scope">
                        <div v-if='scope.row.idCardBack'>
                            <el-image
                                @click='updateSrcList(scope.row.idCardBack)'
                                style="width: 60px; height: 60px"
                                :src="scope.row.idCardBack"
                                :preview-src-list="srcList"> </el-image>
                        </div>
                        <div v-else>-</div>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="licensePic"
                    label="营业执照图片"
                    width="130"
                >
                    <template slot-scope="scope">
                        <div v-if='scope.row.licensePic'>
                            <el-image
                                @click='updateSrcList(scope.row.licensePic)'
                                style="width: 60px; height: 60px"
                                :src="scope.row.licensePic"
                                :preview-src-list="srcList"> </el-image>
                        </div>
                        <div v-else>-</div>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="bankCardFacade"
                    label="银行卡正面图片"
                    width="130"
                >
                    <template slot-scope="scope">
                        <div v-if='scope.row.bankCardFacade'>
                            <el-image
                                @click='updateSrcList(scope.row.bankCardFacade)'
                                style="width: 60px; height: 60px"
                                :src="scope.row.bankCardFacade"
                                :preview-src-list="srcList"> </el-image>
                        </div>
                        <div v-else>-</div>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="bankCardBack"
                    label="银行卡背面图片"
                    width="130"
                >
                    <template slot-scope="scope">
                        <div v-if='scope.row.bankCardBack'>
                            <el-image
                                @click='updateSrcList(scope.row.bankCardBack)'
                                style="width: 60px; height: 60px"
                                :src="scope.row.bankCardBack"
                                :preview-src-list="srcList"> </el-image>
                        </div>
                        <div v-else>-</div>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="wxpayConfirmQrcode"
                    label="微信确认二维码"
                    width="130"
                >
                    <template slot-scope="scope">
                        <div v-if='scope.row.wxpayConfirmQrcode'>
                            <el-image
                                @click='updateSrcList(scope.row.wxpayConfirmQrcode)'
                                style="width: 60px; height: 60px"
                                :src="scope.row.wxpayConfirmQrcode"
                                :preview-src-list="srcList"> </el-image>
                        </div>
                        <div v-else-if="scope.row.wxpayAuthStatus == 5">驳回，请查看报文</div>
                        <div v-else>-</div>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="alipayConfirmQrcode"
                    label="支付宝确认二维码"
                    width="144"
                >
                    <template slot-scope="scope">
                        <div v-if='scope.row.alipayConfirmQrcode'>
                            <el-image
                                @click='updateSrcList(scope.row.alipayConfirmQrcode)'
                                style="width: 60px; height: 60px"
                                :src="scope.row.alipayConfirmQrcode"
                                :preview-src-list="srcList"> </el-image>
                        </div>
                        <div v-else-if="scope.row.alipayAuthStatus == 5">驳回，请查看报文</div>
                        <div v-else>-</div>
                    </template>
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="createTime"
                    label="创建时间"
                    width="180"
                >
                </el-table-column>
<!--                <el-table-column-->
<!--                    :show-overflow-tooltip="true"-->
<!--                    align="center"-->
<!--                    prop="thirdStatus"-->
<!--                    label="银盛审核状态"-->
<!--                    width="130"-->
<!--                >-->
<!--                    <template slot-scope="scope">-->
<!--                        <div class="flex" :class="{'active': scope.row.thirdStatus == 2}">-->
<!--                            <span style="font-size: 25px;margin-top: -5px">●</span>-->
<!--                            <span>{{computeAuditStatus(scope.row.thirdStatus)}}</span>-->
<!--                        </div>-->
<!--                    </template>-->
<!--                </el-table-column>-->
<!--                <el-table-column-->
<!--                    :show-overflow-tooltip="true"-->
<!--                    align="center"-->
<!--                    prop="wxpayStatus"-->
<!--                    label="微信支付审核状态"-->
<!--                    width="130"-->
<!--                >-->
<!--                    <template slot-scope="scope">-->
<!--                        <div class="flex" :class="{'active': scope.row.wxpayStatus}">-->
<!--                            <span style="font-size: 25px;margin-top: -5px">●</span>-->
<!--                            <span v-if="scope.row.wxpayStatus">已认证</span>-->
<!--                            <span v-else>未认证</span>-->
<!--                        </div>-->
<!--                    </template>-->
<!--                </el-table-column>-->
<!--                <el-table-column-->
<!--                    :show-overflow-tooltip="true"-->
<!--                    align="center"-->
<!--                    prop="alipayStatus"-->
<!--                    label="支付宝支付审核状态"-->
<!--                    width="130"-->
<!--                >-->
<!--                    <template slot-scope="scope">-->
<!--                        <div class="flex" :class="{'active': scope.row.alipayStatus}">-->
<!--                            <span style="font-size: 25px;margin-top: -5px">●</span>-->
<!--                            <span v-if="scope.row.alipayStatus">已认证</span>-->
<!--                            <span v-else>未认证</span>-->
<!--                        </div>-->
<!--                    </template>-->
<!--                </el-table-column>-->
<!--                <el-table-column-->
<!--                    :show-overflow-tooltip="true"-->
<!--                    align="center"-->
<!--                    prop="subAccount"-->
<!--                    label="子商户号"-->
<!--                    width="180"-->
<!--                ></el-table-column>-->

<!--                <el-table-column-->
<!--                    :show-overflow-tooltip="true"-->
<!--                    align="center"-->
<!--                    prop="licenseProvinceId"-->
<!--                    label="营业执照省"-->
<!--                    width="180"-->
<!--                ></el-table-column>-->
<!--                <el-table-column-->
<!--                    :show-overflow-tooltip="true"-->
<!--                    align="center"-->
<!--                    prop="licenseCityId"-->
<!--                    label="营业执照市"-->
<!--                    width="180"-->
<!--                ></el-table-column>-->
<!--                <el-table-column-->
<!--                    :show-overflow-tooltip="true"-->
<!--                    align="center"-->
<!--                    prop="licenseAreaId"-->
<!--                    label="营业执照区"-->
<!--                    width="180"-->
<!--                ></el-table-column>-->
<!--                <el-table-column-->
<!--                    :show-overflow-tooltip="true"-->
<!--                    align="center"-->
<!--                    prop="licenseTownId"-->
<!--                    label="营业执照乡镇"-->
<!--                    width="180"-->
<!--                ></el-table-column>-->
<!--                <el-table-column-->
<!--                    :show-overflow-tooltip="true"-->
<!--                    align="center"-->
<!--                    prop="licenseName"-->
<!--                    label="营业执照名称"-->
<!--                    width="180"-->
<!--                ></el-table-column>-->
<!--                <el-table-column-->
<!--                    :show-overflow-tooltip="true"-->
<!--                    align="center"-->
<!--                    prop="licenseAddress"-->
<!--                    label="营业执照地址"-->
<!--                    width="180"-->
<!--                ></el-table-column>-->
<!--                <el-table-column-->
<!--                    :show-overflow-tooltip="true"-->
<!--                    align="center"-->
<!--                    prop="licenseNumber"-->
<!--                    label="社会统一信用代码"-->
<!--                    width="180"-->
<!--                ></el-table-column>-->
<!--                <el-table-column-->
<!--                    :show-overflow-tooltip="true"-->
<!--                    align="center"-->
<!--                    prop="licenseStartTime"-->
<!--                    label="营业执照有效开始日期"-->
<!--                    width="180"-->
<!--                ></el-table-column>-->
<!--                <el-table-column-->
<!--                    :show-overflow-tooltip="true"-->
<!--                    align="center"-->
<!--                    prop="licenseEndTime"-->
<!--                    label="营业执照有效结束日期"-->
<!--                    width="180"-->
<!--                ></el-table-column>-->
<!--                <el-table-column-->
<!--                    :show-overflow-tooltip="true"-->
<!--                    align="center"-->
<!--                    prop="licenseRange"-->
<!--                    label="营业执照经营范围"-->
<!--                    width="180"-->
<!--                ></el-table-column>-->
<!--                <el-table-column-->
<!--                    :show-overflow-tooltip="true"-->
<!--                    align="center"-->
<!--                    prop="personMobile"-->
<!--                    label="法人手机号"-->
<!--                    width="180"-->
<!--                ></el-table-column>-->
<!--                <el-table-column-->
<!--                    :show-overflow-tooltip="true"-->
<!--                    align="center"-->
<!--                    prop="idCard"-->
<!--                    label="身份证号"-->
<!--                    width="180"-->
<!--                ></el-table-column>-->
<!--                <el-table-column-->
<!--                    :show-overflow-tooltip="true"-->
<!--                    align="center"-->
<!--                    prop="idCardStartTime"-->
<!--                    label="身份证有效开始日期"-->
<!--                    width="180"-->
<!--                ></el-table-column>-->
<!--                <el-table-column-->
<!--                    :show-overflow-tooltip="true"-->
<!--                    align="center"-->
<!--                    prop="idCardEndTime"-->
<!--                    label="身份证有效结束日期"-->
<!--                    width="180"-->
<!--                ></el-table-column>-->

<!--                <el-table-column-->
<!--                    :show-overflow-tooltip="true"-->
<!--                    align="center"-->
<!--                    prop="idCardAddress"-->
<!--                    label="身份证地址"-->
<!--                    width="180"-->
<!--                ></el-table-column>-->

<!--                <el-table-column-->
<!--                    :show-overflow-tooltip="true"-->
<!--                    align="center"-->
<!--                    prop="bankHolder"-->
<!--                    label="银行卡持有人"-->
<!--                    width="180"-->
<!--                ></el-table-column>-->
<!--                <el-table-column-->
<!--                    :show-overflow-tooltip="true"-->
<!--                    align="center"-->
<!--                    prop="bankMobile"-->
<!--                    label="银行预留手机号"-->
<!--                    width="180"-->
<!--                ></el-table-column>-->


<!--                <el-table-column-->
<!--                    :show-overflow-tooltip="true"-->
<!--                    align="center"-->
<!--                    prop="bankName"-->
<!--                    label="银行名称"-->
<!--                    width="180"-->
<!--                ></el-table-column>-->
<!--                <el-table-column-->
<!--                    :show-overflow-tooltip="true"-->
<!--                    align="center"-->
<!--                    prop="bankSubbranch"-->
<!--                    label="开户支行名称"-->
<!--                    width="180"-->
<!--                ></el-table-column>-->
<!--                <el-table-column-->
<!--                    :show-overflow-tooltip="true"-->
<!--                    align="center"-->
<!--                    prop="bankProvinceId"-->
<!--                    label="开户行省"-->
<!--                    width="180"-->
<!--                ></el-table-column>-->
<!--                <el-table-column-->
<!--                    :show-overflow-tooltip="true"-->
<!--                    align="center"-->
<!--                    prop="bankCityId"-->
<!--                    label="开户行市"-->
<!--                    width="180"-->
<!--                ></el-table-column>-->
<!--                <el-table-column-->
<!--                    :show-overflow-tooltip="true"-->
<!--                    align="center"-->
<!--                    prop="bankAreaId"-->
<!--                    label="开户行市"-->
<!--                    width="180"-->
<!--                ></el-table-column>-->
<!--                <el-table-column-->
<!--                    :show-overflow-tooltip="true"-->
<!--                    align="center"-->
<!--                    prop="bankTownId"-->
<!--                    label="开户行乡镇"-->
<!--                    width="180"-->
<!--                ></el-table-column>-->

<!--                <el-table-column-->
<!--                    :show-overflow-tooltip="true"-->
<!--                    align="center"-->
<!--                    prop="isSign"-->
<!--                    label="是否签名 0否 1是"-->
<!--                    width="180"-->
<!--                ></el-table-column>-->
<!--                <el-table-column-->
<!--                    :show-overflow-tooltip="true"-->
<!--                    align="center"-->
<!--                    prop="signPic"-->
<!--                    label="签名图片"-->
<!--                    width="180"-->
<!--                ></el-table-column>-->
<!--                <el-table-column-->
<!--                    :show-overflow-tooltip="true"-->
<!--                    align="center"-->
<!--                    prop="contractUrl"-->
<!--                    label="合同地址"-->
<!--                    width="180"-->
<!--                ></el-table-column>-->
<!--                <el-table-column-->
<!--                    :show-overflow-tooltip="true"-->
<!--                    align="center"-->
<!--                    prop="otherInfor"-->
<!--                    label="其他补充资料 如烟草经营许可证"-->
<!--                    width="180"-->
<!--                ></el-table-column>-->
                <el-table-column
                    fixed="right"
                    align="center"
                    label="操作"
                    width="380"
                >
                    <template slot-scope="scop">
                        <div class="operation">
                            <div @click='ShopStoreAudit(scop.row)' v-if='scop.row.store.status == 1'>
                                <el-button type='primary' size='mini'>驳回</el-button>
                            </div>
                            <div @click="checkShopStoreOrgInfo(scop.row.id)">
                                <Icon size="16">
                                    <Eye24Regular />
                                </Icon>
                                <span class="operation-label">查看</span>
                            </div>
                            <div @click="editShopStoreOrgInfo(scop.row.id)">
                                <Icon size="16">
                                    <Edit24Regular />
                                </Icon>
                                <span class="operation-label">修改</span>
                            </div>
                            <div @click="resetStatus(scop.row.id,'wechat')">
                                <Icon size="16">
                                    <Eye24Regular />
                                </Icon>
                                <span class="operation-label">微信重置</span>
                            </div>
                            <div @click="resetStatus(scop.row.id,'ali')">
                                <Icon size="16">
                                    <Eye24Regular />
                                </Icon>
                                <span class="operation-label">支付宝重置</span>
                            </div>
<!--                            <div @click="deleteShopStoreOrgInfo(scop.row.id)">-->
<!--                                <Icon size="16" style="color: red">-->
<!--                                    <Delete24Regular />-->
<!--                                </Icon>-->
<!--                                <span class="operation-label" style="color: red">删除</span>-->
<!--                            </div>-->
                        </div>
                        <div class="operation">
                            <div @click="onRegister(scop.row.storeId)">
                                <span class="operation-label">提交进件</span>
                            </div>
                            <div @click="wxReport(scop.row.storeId)">
                                <span class="operation-label">微信认证</span>
                            </div>
                            <div @click="aliReport(scop.row.storeId)">
                                <span class="operation-label">支付宝认证</span>
                            </div>
                            <div @click="reportBei(scop.row.storeId)">
                                <span class="operation-label">申请报备</span>
                            </div>
                        </div>
<!--                        <div>-->
<!--                            <el-button type="primary" size="mini">提审进件</el-button>-->
<!--                            <el-button type="primary" size="mini">微信认证</el-button>-->
<!--                        </div>-->
<!--                        <div>-->
<!--                            <el-button type="primary" size="mini">支付宝认证</el-button>-->
<!--                            <el-button type="primary" size="mini">申请报备</el-button>-->
<!--                        </div>-->
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-box">
                <el-pagination
                    @size-change="sizeChange"
                    @current-change="currentChange"
                    :current-page.sync="currentPage"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalNum"
                    background
                    :pager-count="7"
                >
                </el-pagination>
            </div>
            <!-- 新增/查看/修改信息 -->
            <el-dialog
                :title="shopStoreOrginfoStates[shopStoreOrginfoState]"
                :visible.sync="showDialog"
                width="60%"
                @close="closeDialog"
            >
                <div>
                    <el-form
                        :model="shopStoreOrginfo"
                        ref="shopStoreOrginfoForm"
                        :rules="rules"
                        label-width="120px"
                        :inline="true"
                        size="small"
                    >
                        <el-tabs type="border-card">
                            <el-tab-pane label="工商信息">
                                <el-form-item
                                    label="组织类型"
                                    prop="orgType"
                                >
                                    <el-select
                                        v-model="shopStoreOrginfo.orgType"
                                        size="small"
                                        placeholder="请选择组织类型"
                                        clearable
                                        style="width: 200px"
                                    >
                                        <el-option v-for="(item,index) in storeOrgTypeStatusEunmList" :label="item.value" :value="item.key"> </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item
                                    label="执照所属省份"
                                    prop="licenseProvinceId"
                                >
                                    <el-select
                                        style='width:200px'
                                        v-model='shopStoreOrginfo.licenseProvinceId'
                                        size='small'
                                        placeholder='请选择省份'
                                    >
                                        <el-option
                                            v-for='item in provinceIdList'
                                            :key='item.id'
                                            :label='item.name'
                                            :value='item.id'
                                        ></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item
                                    label="执照所属城市"
                                    prop="licenseCityId"
                                >
                                    <el-select
                                        style='width:200px'
                                        v-model='shopStoreOrginfo.licenseCityId'
                                        size='small'
                                        placeholder='请选择城市'
                                    >
                                        <el-option
                                            v-for='item in cityIdList'
                                            :key='item.id'
                                            :label='item.name'
                                            :value='item.id'
                                        ></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item
                                    label="执照所属区县"
                                    prop="licenseAreaId"
                                >
                                    <el-select
                                        style='width:200px'
                                        v-model='shopStoreOrginfo.licenseAreaId'
                                        size='small'
                                        placeholder='请选择区县'
                                    >
                                        <el-option
                                            v-for='item in areaIdList'
                                            :key='item.id'
                                            :label='item.name'
                                            :value='item.id'
                                        ></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item
                                    label="执照所属乡镇"
                                    prop="licenseTownId"
                                >
                                    <el-select
                                        style='width:200px'
                                        v-model='shopStoreOrginfo.licenseTownId'
                                        size='small'
                                        placeholder='请选择乡镇'
                                    >
                                        <el-option
                                            v-for='item in streetIdList'
                                            :key='item.id'
                                            :label='item.name'
                                            :value='item.id'
                                        ></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item
                                    label="营业执照名称"
                                    prop="licenseName"
                                >
                                    <el-input
                                        size="small"
                                        style="width: 200px"
                                        v-model="shopStoreOrginfo.licenseName"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item
                                    label="营业执照注册地址"
                                    prop="licenseAddress"
                                >
                                    <el-input
                                        size="small"
                                        style="width: 200px"
                                        v-model="shopStoreOrginfo.licenseAddress"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item
                                    label="统一社会信用代码"
                                    prop="licenseNumber"
                                >
                                    <el-input
                                        size="small"
                                        style="width: 200px"
                                        v-model="shopStoreOrginfo.licenseNumber"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item
                                    label="经营期限起始"
                                    prop="licenseStartTime"
                                >
                                    <div style="width: 200px;display: flex;align-items: center;">
                                        <el-date-picker
                                            style="flex: 1"
                                            size="small"
                                            v-model="shopStoreOrginfo.licenseStartTime"
                                            type="date"
                                            value-format="yyyy-MM-dd"
                                            placeholder="选择日期">
                                        </el-date-picker>
                                        <el-checkbox style="margin-left: 10px" :true-label="1" :false-label="0" v-model="shopStoreOrginfo.licenseIsPermanent" label="长期"></el-checkbox>
                                    </div>

                                </el-form-item>
                                <el-form-item
                                    label="经营期限结束"
                                    prop="licenseEndTime"
                                    v-if="shopStoreOrginfo.licenseIsPermanent == 0"
                                >
                                    <el-date-picker
                                        style="width: 200px;"
                                        size="small"
                                        v-model="shopStoreOrginfo.licenseEndTime"
                                        type="date"
                                        value-format="yyyy-MM-dd"
                                        placeholder="选择日期">
                                    </el-date-picker>
                                </el-form-item>
                                <el-form-item
                                    label="经营范围"
                                    prop="licenseRange"
                                >
                                    <el-input
                                        size="small"
                                        type="textarea"
                                        :rows="8"
                                        style="width: 200px"
                                        v-model="shopStoreOrginfo.licenseRange"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item
                                    label="营业执照图片"
                                    prop="licensePic"
                                >
                                    <div style="width: 200px;display: flex;">
                                        <el-upload :action="action" :headers="header" :before-upload="beforeImageUpload"
                                                   class="avatar-uploader" :show-file-list="false"
                                                   :http-request="uploadImage21">
                                            <img v-if="shopStoreOrginfo.licensePic" :src="shopStoreOrginfo.licensePic" class="avatar" size="small" />
                                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                        </el-upload>
                                        <el-button style="margin-left: 10px;height: 28px" size="mini" type="primary" @click="getImage(shopStoreOrginfo.licensePic)">查看</el-button>
                                    </div>
                                </el-form-item>
                                <!--                        <el-form-item-->
                                <!--                            label="其他补充资料 如烟草经营许可证"-->
                                <!--                            prop="otherInfor"-->
                                <!--                        >-->
                                <!--                            <el-upload :action="action" :headers="header" :before-upload="beforeImageUpload"-->
                                <!--                                       class="avatar-uploader" :show-file-list="false"-->
                                <!--                                       :http-request="uploadImage22">-->
                                <!--                                <img v-if="shopStoreOrginfo.otherInfor" :src="shopStoreOrginfo.otherInfor" class="avatar" size="small" />-->
                                <!--                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>-->
                                <!--                            </el-upload>-->
                                <!--                        </el-form-item>-->
                            </el-tab-pane>
                            <el-tab-pane label="法人信息">
                                <el-form-item
                                    label="法人姓名"
                                    prop="personName"
                                >
                                    <el-input
                                        size="small"
                                        style="width: 200px"
                                        v-model="shopStoreOrginfo.personName"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item
                                    label="身份证号"
                                    prop="idCard"
                                >
                                    <el-input
                                        size="small"
                                        style="width: 200px"
                                        v-model="shopStoreOrginfo.idCard"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item
                                    label="证件有效期起始"
                                    prop="idCardStartTime"
                                >
                                    <div style="width: 200px;display: flex;align-items: center">
                                        <el-date-picker
                                            style="flex: 1"
                                            size="small"
                                            v-model="shopStoreOrginfo.idCardStartTime"
                                            type="date"
                                            value-format="yyyy-MM-dd"
                                            placeholder="选择日期">
                                        </el-date-picker>
                                        <el-checkbox style="margin-left: 10px" :true-label="1" :false-label="0" v-model="shopStoreOrginfo.idCardIsPermanent" label="长期"></el-checkbox>
                                    </div>
                                </el-form-item>
                                <el-form-item
                                    label="证件有效期结束"
                                    prop="idCardEndTime"
                                    v-if="shopStoreOrginfo.idCardIsPermanent==0"
                                >
                                    <el-date-picker
                                        style="width: 200px;"
                                        size="small"
                                        v-model="shopStoreOrginfo.idCardEndTime"
                                        type="date"
                                        value-format="yyyy-MM-dd"
                                        placeholder="选择日期">
                                    </el-date-picker>
                                </el-form-item>
                                <el-form-item
                                    label="证件地址"
                                    prop="idCardAddress"
                                >
                                    <el-input
                                        size="small"
                                        style="width: 200px"
                                        v-model="shopStoreOrginfo.idCardAddress"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item
                                    label="身份证人像面图片"
                                    prop="idCardFacade"
                                >
                                    <div style="display: flex;width: 200px;">
                                        <el-upload :action="action" :headers="header" :before-upload="beforeImageUpload"
                                                   class="avatar-uploader" :show-file-list="false"
                                                   :http-request="uploadImage31">
                                            <img v-if="shopStoreOrginfo.idCardFacade" :src="shopStoreOrginfo.idCardFacade" class="avatar" size="small" />
                                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                        </el-upload>
                                        <el-button style="margin-left: 10px;height: 28px" size="mini" type="primary" @click="getImage(shopStoreOrginfo.idCardFacade)">查看</el-button>
                                    </div>
                                </el-form-item>
                                <el-form-item
                                    label="身份证国徽面图片"
                                    prop="idCardBack"
                                >
                                    <div style="display: flex;width: 200px;">
                                        <el-upload :action="action" :headers="header" :before-upload="beforeImageUpload"
                                                   class="avatar-uploader" :show-file-list="false"
                                                   :http-request="uploadImage32">
                                            <img v-if="shopStoreOrginfo.idCardBack" :src="shopStoreOrginfo.idCardBack" class="avatar" size="small" />
                                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                        </el-upload>
                                        <el-button style="margin-left: 10px;height: 28px" size="mini" type="primary" @click="getImage(shopStoreOrginfo.idCardBack)">查看</el-button>
                                    </div>
                                </el-form-item>
                            </el-tab-pane>
                            <el-tab-pane label="银行信息">
                                <el-form-item
                                    label="对公账户名称/持有人姓名"
                                    prop="bankHolder"
                                >
                                    <el-input
                                        size="small"
                                        style="width: 200px"
                                        v-model="shopStoreOrginfo.bankHolder"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item
                                    label="对公账户卡号/银行卡卡号"
                                    prop="bankAccount"
                                >
                                    <el-input
                                        size="small"
                                        style="width: 200px"
                                        v-model="shopStoreOrginfo.bankAccount"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item
                                    label="所属银行"
                                    prop="bankName"
                                >
                                    <el-input
                                        size="small"
                                        style="width: 200px"
                                        v-model="shopStoreOrginfo.bankName"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item
                                    label="开户支行"
                                    prop="bankSubbranch"
                                >
                                    <el-input
                                        size="small"
                                        style="width: 200px"
                                        v-model="shopStoreOrginfo.bankSubbranch"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item
                                    label="银行所在省份"
                                    prop="bankProvinceId"
                                >
                                    <el-select
                                        style='width:200px'
                                        v-model='shopStoreOrginfo.bankProvinceId'
                                        size='small'
                                        placeholder='请选择省份'
                                    >
                                        <el-option
                                            v-for='item in provinceIdList'
                                            :key='item.id'
                                            :label='item.name'
                                            :value='item.id'
                                        ></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item
                                    label="银行所在城市"
                                    prop="bankCityId"
                                >
                                    <el-select
                                        style='width:200px'
                                        v-model='shopStoreOrginfo.bankCityId'
                                        size='small'
                                        placeholder='请选择城市'
                                    >
                                        <el-option
                                            v-for='item in cityIdList2'
                                            :key='item.id'
                                            :label='item.name'
                                            :value='item.id'
                                        ></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item
                                    label="银行所在区县"
                                    prop="bankAreaId"
                                >
                                    <el-select
                                        style='width:200px'
                                        v-model='shopStoreOrginfo.bankAreaId'
                                        size='small'
                                        placeholder='请选择区县'
                                    >
                                        <el-option
                                            v-for='item in areaIdList2'
                                            :key='item.id'
                                            :label='item.name'
                                            :value='item.id'
                                        ></el-option>
                                    </el-select>
                                </el-form-item>
<!--                                <el-form-item-->
<!--                                    label="银行所在乡镇"-->
<!--                                    prop="bankTownId"-->
<!--                                >-->
<!--                                    <el-select-->
<!--                                        style='width:200px'-->
<!--                                        v-model='shopStoreOrginfo.bankTownId'-->
<!--                                        size='small'-->
<!--                                        placeholder='请选择乡镇'-->
<!--                                    >-->
<!--                                        <el-option-->
<!--                                            v-for='item in streetIdList2'-->
<!--                                            :key='item.id'-->
<!--                                            :label='item.name'-->
<!--                                            :value='item.id'-->
<!--                                        ></el-option>-->
<!--                                    </el-select>-->
<!--                                </el-form-item>-->
                                <el-form-item
                                    label="银行预留手机号"
                                    prop="bankMobile"
                                >
                                    <el-input
                                        size="small"
                                        style="width: 200px"
                                        v-model="shopStoreOrginfo.bankMobile"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item
                                    label="银行卡正面图片"
                                    prop="bankCardFacade"
                                    v-if="shopStoreOrginfo.orgType != 2"
                                >
                                    <div style="display: flex;width: 200px;">
                                        <el-upload :action="action" :headers="header" :before-upload="beforeImageUpload"
                                                   class="avatar-uploader" :show-file-list="false"
                                                   :http-request="uploadImage41">
                                            <img v-if="shopStoreOrginfo.bankCardFacade" :src="shopStoreOrginfo.bankCardFacade" class="avatar" size="small" />
                                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                        </el-upload>
                                        <el-button style="margin-left: 10px;height: 28px" size="mini" type="primary" @click="getImage(shopStoreOrginfo.bankCardFacade)">查看</el-button>
                                    </div>
                                </el-form-item>
                                <el-form-item
                                    label="银行卡背面图片"
                                    prop="bankCardBack"
                                    v-if="shopStoreOrginfo.orgType != 2"
                                >
                                    <div style="display: flex;width: 200px;">
                                        <el-upload :action="action" :headers="header" :before-upload="beforeImageUpload"
                                                   class="avatar-uploader" :show-file-list="false"
                                                   :http-request="uploadImage42">
                                            <img v-if="shopStoreOrginfo.bankCardBack" :src="shopStoreOrginfo.bankCardBack" class="avatar" size="small" />
                                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                        </el-upload>
                                        <el-button style="margin-left: 10px;height: 28px" size="mini" type="primary" @click="getImage(shopStoreOrginfo.bankCardBack)">查看</el-button>
                                    </div>
                                </el-form-item>
                                <el-form-item
                                    label="对公账户凭证"
                                    prop="bankAccountVoucher"
                                    v-if="shopStoreOrginfo.orgType == 2"
                                >
                                    <div style="display: flex;width: 200px;">
                                        <el-upload :action="action" :headers="header" :before-upload="beforeImageUpload"
                                                   class="avatar-uploader" :show-file-list="false"
                                                   :http-request="uploadImage43">
                                            <img v-if="shopStoreOrginfo.bankAccountVoucher" :src="shopStoreOrginfo.bankAccountVoucher" class="avatar" size="small" />
                                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                        </el-upload>
                                        <el-button style="margin-left: 10px;height: 28px" size="mini" type="primary" @click="getImage(shopStoreOrginfo.bankAccountVoucher)">查看</el-button>
                                    </div>
                                </el-form-item>
                            </el-tab-pane>
                            <el-tab-pane label="认证信息">
                                <el-form-item
                                    label="银盛支付审核状态"
                                    prop="thirdStatus"
                                >
                                    <el-select
                                        v-model="shopStoreOrginfo.thirdStatus"
                                        size="small"
                                        placeholder="请选择支付审核状态"
                                        clearable
                                        style="width: 200px"
                                    >
                                        <el-option v-for="(item,index) in auditStatusEnumList" :label="item.value" :value="item.key"> </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item
                                    label="银盛子商户号"
                                    prop="subAccount"
                                >
                                    <el-input
                                        size="small"
                                        style="width: 200px"
                                        v-model="shopStoreOrginfo.subAccount"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item
                                    label="银盛响应报文"
                                    prop="resultMsg"
                                >
                                    <el-input
                                        size="small"
                                        type="textarea"
                                        :rows="8"
                                        style="width: 200px"
                                        v-model="shopStoreOrginfo.resultMsg"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item
                                    label="微信支付认证状态"
                                    prop="wxpayStatus"
                                >
                                    <el-select
                                        v-model="shopStoreOrginfo.wxpayStatus"
                                        size="small"
                                        placeholder="请选择微信支付认证状态"
                                        clearable
                                        style="width: 200px"
                                    >
                                        <el-option label="未认证" :value="0"> </el-option>
                                        <el-option label="已认证" :value="1"> </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item
                                    label="微信商户号1"
                                    prop="wxpayNo"
                                >
                                    <el-input
                                        size="small"
                                        style="width: 200px"
                                        v-model="shopStoreOrginfo.wxpayNo"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item
                                    label="微信商户号2"
                                    prop="wxpayNo1"
                                >
                                    <el-input
                                        size="small"
                                        style="width: 200px"
                                        v-model="shopStoreOrginfo.wxpayNo1"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item
                                    label="微信申请二维码"
                                    prop="wxpayApplyQrcode"
                                >
                                    <div style="display:flex;width: 200px;">
                                        <el-upload :action="action" :headers="header" :before-upload="beforeImageUpload"
                                                   class="avatar-uploader" :show-file-list="false"
                                                   :http-request="uploadImage51">
                                            <img v-if="shopStoreOrginfo.wxpayApplyQrcode" :src="shopStoreOrginfo.wxpayApplyQrcode" class="avatar" size="small" />
                                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                        </el-upload>
                                        <el-button style="margin-left: 10px;height: 28px" size="mini" type="primary" @click="getImage(shopStoreOrginfo.wxpayApplyQrcode)">查看</el-button>
                                    </div>
                                </el-form-item>
                                <el-form-item
                                    label="微信法人确认二维码"
                                    prop="wxpayConfirmQrcode"
                                >
                                    <div style="display:flex;width: 200px;">
                                        <el-upload :action="action" :headers="header" :before-upload="beforeImageUpload"
                                                   class="avatar-uploader" :show-file-list="false"
                                                   :http-request="uploadImage52">
                                            <img v-if="shopStoreOrginfo.wxpayConfirmQrcode" :src="shopStoreOrginfo.wxpayConfirmQrcode" class="avatar" size="small" />
                                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                        </el-upload>
                                        <el-button style="margin-left: 10px;height: 28px" size="mini" type="primary" @click="getImage(shopStoreOrginfo.wxpayConfirmQrcode)">查看</el-button>
                                    </div>
                                </el-form-item>
                                <el-form-item
                                    label="支付宝支付认证状态"
                                    prop="alipayStatus"
                                >
                                    <el-select
                                        v-model="shopStoreOrginfo.alipayStatus"
                                        size="small"
                                        placeholder="请选择支付宝支付认证状态"
                                        clearable
                                        style="width: 200px"
                                    >
                                        <el-option label="未认证" :value="0"> </el-option>
                                        <el-option label="已认证" :value="1"> </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item
                                    label="支付宝商户号1"
                                    prop="alipayNo"
                                >
                                    <el-input
                                        size="small"
                                        style="width: 200px"
                                        v-model="shopStoreOrginfo.alipayNo"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item
                                    label="支付宝商户号2"
                                    prop="alipayNo1"
                                >
                                    <el-input
                                        size="small"
                                        style="width: 200px"
                                        v-model="shopStoreOrginfo.alipayNo1"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item
                                    label="支付宝申请二维码"
                                    prop="alipayApplyQrcode"
                                >
                                    <div style="display:flex;width: 200px;">
                                        <el-upload :action="action" :headers="header" :before-upload="beforeImageUpload"
                                                   class="avatar-uploader" :show-file-list="false"
                                                   :http-request="uploadImage53">
                                            <img v-if="shopStoreOrginfo.alipayApplyQrcode" :src="shopStoreOrginfo.alipayApplyQrcode" class="avatar" size="small" />
                                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                        </el-upload>
                                        <el-button style="margin-left: 10px;height: 28px" size="mini" type="primary" @click="getImage(shopStoreOrginfo.alipayApplyQrcode)">查看</el-button>
                                    </div>
                                </el-form-item>
                                <el-form-item
                                    label="支付宝法人确认二维码"
                                    prop="alipayConfirmQrcode"
                                >
                                    <div style="display:flex;width: 200px;">
                                        <el-upload :action="action" :headers="header" :before-upload="beforeImageUpload"
                                                   class="avatar-uploader" :show-file-list="false"
                                                   :http-request="uploadImage54">
                                            <img v-if="shopStoreOrginfo.alipayConfirmQrcode" :src="shopStoreOrginfo.alipayConfirmQrcode" class="avatar" size="small" />
                                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                        </el-upload>
                                        <el-button style="margin-left: 10px;height: 28px" size="mini" type="primary" @click="getImage(shopStoreOrginfo.alipayConfirmQrcode)">查看</el-button>
                                    </div>
                                </el-form-item>
                            </el-tab-pane>
                            <el-tab-pane label="签约信息">
                                <el-form-item
                                    label="签约状态"
                                    prop="alipayStatus"
                                >
                                    <el-select
                                        v-model="shopStoreOrginfo.isSign"
                                        size="small"
                                        placeholder="请选择签约状态"
                                        clearable
                                        style="width: 200px"
                                    >
                                        <el-option label="未签约" :value="0"> </el-option>
                                        <el-option label="已签约" :value="1"> </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item
                                    label="签名图片"
                                    prop="signPic"
                                >
                                   <div style="display:flex;width: 200px;">
                                       <el-upload :action="action" :headers="header" :before-upload="beforeImageUpload"
                                                  class="avatar-uploader" :show-file-list="false"
                                                  :http-request="uploadImage11">
                                           <img v-if="shopStoreOrginfo.signPic" :src="shopStoreOrginfo.signPic" class="avatar" size="small" />
                                           <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                       </el-upload>
                                       <el-button style="margin-left: 10px;height: 28px" size="mini" type="primary" @click="getImage(shopStoreOrginfo.signPic)">查看</el-button>
                                   </div>
                                </el-form-item>
                                <el-form-item
                                    label="合同地址"
                                    prop="contractUrl"
                                >
                                    <div style="display:flex;width: 200px;">
                                        <el-upload :action="action" :headers="header" :before-upload="beforeImageUpload"
                                                   class="avatar-uploader" :show-file-list="false"
                                                   :http-request="uploadImage12">
                                            <img v-if="shopStoreOrginfo.contractUrl" :src="shopStoreOrginfo.contractUrl" class="avatar" size="small" />
                                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                        </el-upload>
                                        <el-button style="margin-left: 10px;height: 28px" size="mini" type="primary" @click="getImage(shopStoreOrginfo.contractUrl)">查看</el-button>
                                    </div>
                                </el-form-item>
                            </el-tab-pane>
                        </el-tabs>
                        <el-image ref="images" v-show="false" @click='updateSrcList(imageSrc)' style="width: 60px; height: 60px"
                                  :src="imageSrc" :preview-src-list="srcList"> </el-image>
                    </el-form>
                </div>

                <div
                    slot="footer"
                >
                    <el-button @click="closeDialog">关闭</el-button>
                    <el-button
                        type="primary"
                        @click="submitForm"
                        v-if="shopStoreOrginfoState != 'check'"
                    >确定
                    </el-button>
                </div>
            </el-dialog>

            <!--审核功能-->
            <el-dialog title='审核驳回' :visible.sync='retreatDialogVisible' width='30%'
                       :before-close='handleCloseRetreat'>
                <el-form ref='retreatForm' :rules='retreatRules' size='small' :model='retreatForm' label-width='100px'>
                    <el-form-item label='申请说明：'>
                        <el-input style='width: 100%' type='textarea' v-model='applyRemarks'
                                  :disabled='true'></el-input>
                    </el-form-item>
                    <el-form-item label='驳回原因：' prop='desc'>
                        <el-input style='width: 100%' type='textarea' v-model='retreatForm.desc'></el-input>
                    </el-form-item>
                    <!--                <el-form-item label='收益比例：' v-if="retreatForm.resource == 'true'" prop='incomeRatio'>-->
                    <!--                    <el-input style='width: 200px' v-model='retreatForm.incomeRatio'></el-input>-->
                    <!--                </el-form-item>-->
                </el-form>
                <span slot='footer' class='dialog-footer'>
        <el-button @click='handleCloseRetreat'>取 消</el-button>
        <el-button type='primary' @click="retreatSuccess('retreatForm')">确 定</el-button>
      </span>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun, upload } from '@/utils/request.js';
import { UPLOAD_API, UPLOAD_PATH, USER, USER_SEARCH } from '@/utils/constant';
import GridSelectU from '@/components/gridselect/index.vue';

export default {
    components: {
        GridSelectU,
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
    watch: {
        checkState(val) {
            if (val == 'check') {
                this.resetShopStoreOrgInfoList();
                this.getShopStoreOrgInfoList(this.queryForm);
                this.$emit('resetCheckState');
            } else if (val == 'reset') {
                this.resetShopStoreOrgInfoList();
                this.getShopStoreOrgInfoList();
                this.$emit('resetCheckState');
            }
        },
        //市
        'shopStoreOrginfo.licenseProvinceId'(id) {
            if(!id){
                return;
            }
            setTimeout(() => {
                if (!this.getCity) {
                    this.shopStoreOrginfo.licenseCityId = '';
                    this.shopStoreOrginfo.licenseAreaId = '';
                    this.shopStoreOrginfo.licenseTownId = '';
                } else {
                    this.getCity = !this.getCity;
                }
                this.getAddress(2,id)
            }, 5);
        },
        //区
        'shopStoreOrginfo.licenseCityId'(id) {
            if(!id){
                return;
            }
            setTimeout(() => {
                if (!this.getArea) {
                    this.shopStoreOrginfo.licenseAreaId = '';
                    this.shopStoreOrginfo.licenseTownId = '';
                } else {
                    this.getArea = !this.getArea;
                }
                this.getAddress(3,id)
            }, 10);
        },
        //社区
        'shopStoreOrginfo.licenseAreaId'(id) {
            if(!id){
                return;
            }
            setTimeout(() => {
                if (!this.street) {
                    this.shopStoreOrginfo.licenseTownId = '';
                } else {
                    this.street = !this.street;
                }
                this.getAddress(4,id)
            }, 15);
        },
        //市
        'shopStoreOrginfo.bankProvinceId'(id) {
            if(!id){
                return;
            }
            setTimeout(() => {
                if (!this.getCity2) {
                    this.shopStoreOrginfo.bankCityId = '';
                    this.shopStoreOrginfo.bankAreaId = '';
                    this.shopStoreOrginfo.bankTownId = '';
                } else {
                    this.getCity2 = !this.getCity2;
                }
                this.getAddress2(2,id)
            }, 25);
        },
        //区
        'shopStoreOrginfo.bankCityId'(id) {
            if(!id){
                return;
            }
            setTimeout(() => {
                if (!this.getArea2) {
                    this.shopStoreOrginfo.bankAreaId = '';
                    this.shopStoreOrginfo.bankTownId = '';
                } else {
                    this.getArea2 = !this.getArea2;
                }
                this.getAddress2(3,id)
            }, 30);
        },
        //社区
        'shopStoreOrginfo.bankAreaId'(id) {
            if(!id){
                return;
            }
            setTimeout(() => {
                if (!this.street2) {
                    this.shopStoreOrginfo.bankTownId = '';
                } else {
                    this.street2 = !this.street2;
                }
                this.getAddress2(4,id)
            }, 35);
        },
    },
    data() {
        return {
            auditStatusEnumList: [],
            storeOrgTypeStatusEunmList: [],
            yesNoEunmList: [],
            srcList: [''],

            queryForm: {
                userId: '', //用户id
                storeId: '', //门店id
                subAccount: '', //子商户号
                orgType: '', //组织类型 1小微 2企业 3个体
                licensePic: '', //营业执照图片
                licenseProvinceId: '', //营业执照省
                licenseCityId: '', //营业执照市
                licenseAreaId: '', //营业执照区
                licenseTownId: '', //营业执照乡镇
                licenseName: '', //营业执照名称
                licenseAddress: '', //营业执照地址
                licenseNumber: '', //社会统一信用代码
                licenseStartTime: '', //营业执照有效开始日期
                licenseEndTime: '', //营业执照有效结束日期
                licenseRange: '', //营业执照经营范围
                personName: '', //法人姓名
                personMobile: '', //法人手机号
                idCard: '', //身份证号
                idCardStartTime: '', //身份证有效开始日期
                idCardEndTime: '', //身份证有效结束日期
                idCardFacade: '', //身份证正面图片
                idCardBack: '', //身份证背面图片
                idCardAddress: '', //身份证地址
                bankAccount: '', //银行账号
                bankHolder: '', //银行卡持有人
                bankMobile: '', //银行预留手机号
                bankCardFacade: '', //银行卡正面图片
                bankCardBack: '', //银行卡背面图片
                bankAccountVoucher: '', //对公账户凭证
                bankName: '', //银行名称
                bankSubbranch: '', //开户支行名称
                bankProvinceId: '', //开户行省
                bankCityId: '', //开户行市
                bankAreaId: '', //开户行市
                bankTownId: '', //开户行乡镇
                thirdStatus: '', //支付审核状态
                alipayStatus: '', //支付宝支付审核状态
                wxpayStatus: '', //微信支付审核状态
                resultMsg: '', //响应报文
                isSign: '', //是否签名 0否 1是
                signPic: '', //签名图片
                contractUrl: '', //合同地址
                otherInfor: '', //其他补充资料 如烟草经营许可证
            },
            loading: false,
            showDialog: false,
            isImportDate: false,
            isSearch: false,
            pageSize: 10,
            currentPage: 1,
            totalNum: 0,
            currentUserId: '',
            shopStoreOrginfoState: 'add',
            shopStoreOrginfoStates: {
                add: '新建进件资料',
                check: '查看进件资料',
                edit: '修改进件资料'
            },
            fullscreenLoading: false,
            multipleSelection: [],
            shopStoreOrginfoList: [],
            shopStoreOrginfo: {
                userId: '', //用户id
                storeId: '', //门店id
                subAccount: '', //子商户号
                orgType: '', //组织类型 1小微 2企业 3个体
                licensePic: '', //营业执照图片
                licenseProvinceId: '', //营业执照省
                licenseCityId: '', //营业执照市
                licenseAreaId: '', //营业执照区
                licenseTownId: '', //营业执照乡镇
                licenseName: '', //营业执照名称
                licenseAddress: '', //营业执照地址
                licenseNumber: '', //社会统一信用代码
                licenseStartTime: '', //营业执照有效开始日期
                licenseEndTime: '', //营业执照有效结束日期
                licenseRange: '', //营业执照经营范围
                personName: '', //法人姓名
                personMobile: '', //法人手机号
                idCard: '', //身份证号
                idCardStartTime: '', //身份证有效开始日期
                idCardEndTime: '', //身份证有效结束日期
                idCardFacade: '', //身份证正面图片
                idCardBack: '', //身份证背面图片
                idCardAddress: '', //身份证地址
                bankAccount: '', //银行账号
                bankHolder: '', //银行卡持有人
                bankMobile: '', //银行预留手机号
                bankCardFacade: '', //银行卡正面图片
                bankCardBack: '', //银行卡背面图片
                bankAccountVoucher: '', //对公账户凭证
                bankName: '', //银行名称
                bankSubbranch: '', //开户支行名称
                bankProvinceId: '', //开户行省
                bankCityId: '', //开户行市
                bankAreaId: '', //开户行市
                bankTownId: '', //开户行乡镇
                thirdStatus: '', //支付审核状态
                alipayStatus: '', //支付宝支付审核状态
                wxpayStatus: '', //微信支付审核状态
                resultMsg: '', //响应报文
                isSign: '', //是否签名 0否 1是
                signPic: '', //签名图片
                contractUrl: '', //合同地址
                otherInfor: '', //其他补充资料
                wxpayNo: '',
                wxpayNo1: '',
                alipayNo: '',
                alipayNo1: '',
                wxpayApplyQrcode: '',
                wxpayConfirmQrcode: '',
                alipayApplyQrcode: '',
                alipayConfirmQrcode: '',
            },
            btnLoading: false,

            rules: {
                // subAccount: [{ required: true, message: '子商户号不能为空', trigger: 'blur' }],
                orgType: [{ required: true, message: '组织类型 1小微 2企业 3个体不能为空', trigger: 'blur' }],
                licensePic: [{ required: true, message: '营业执照图片不能为空', trigger: 'blur' }],
                licenseProvinceId: [{ required: true, message: '营业执照省不能为空', trigger: 'blur' }],
                licenseCityId: [{ required: true, message: '营业执照市不能为空', trigger: 'blur' }],
                licenseAreaId: [{ required: true, message: '营业执照区不能为空', trigger: 'blur' }],
                licenseTownId: [{ required: true, message: '营业执照乡镇不能为空', trigger: 'blur' }],
                licenseName: [{ required: true, message: '营业执照名称不能为空', trigger: 'blur' }],
                licenseAddress: [{ required: true, message: '营业执照地址不能为空', trigger: 'blur' }],
                licenseNumber: [{ required: true, message: '社会统一信用代码不能为空', trigger: 'blur' }],
                licenseStartTime: [{ required: true, message: '营业执照有效开始日期不能为空', trigger: 'blur' }],
                licenseEndTime: [{ required: true, message: '营业执照有效结束日期不能为空', trigger: 'blur' }],
                licenseRange: [{ required: true, message: '营业执照经营范围不能为空', trigger: 'blur' }],
                personName: [{ required: true, message: '法人姓名不能为空', trigger: 'blur' }],
                personMobile: [{ required: true, message: '法人手机号不能为空', trigger: 'blur' }],
                idCard: [{ required: true, message: '身份证号不能为空', trigger: 'blur' }],
                idCardStartTime: [{ required: true, message: '身份证有效开始日期不能为空', trigger: 'blur' }],
                idCardEndTime: [{ required: true, message: '身份证有效结束日期不能为空', trigger: 'blur' }],
                idCardFacade: [{ required: true, message: '身份证正面图片不能为空', trigger: 'blur' }],
                idCardBack: [{ required: true, message: '身份证背面图片不能为空', trigger: 'blur' }],
                idCardAddress: [{ required: true, message: '身份证地址不能为空', trigger: 'blur' }],
                bankAccount: [{ required: true, message: '银行账号不能为空', trigger: 'blur' }],
                bankHolder: [{ required: true, message: '银行卡持有人不能为空', trigger: 'blur' }],
                bankMobile: [{ required: true, message: '银行预留手机号不能为空', trigger: 'blur' }],
                bankCardFacade: [{ required: true, message: '银行卡正面图片不能为空', trigger: 'blur' }],
                bankCardBack: [{ required: true, message: '银行卡背面图片不能为空', trigger: 'blur' }],
                bankAccountVoucher: [{ required: true, message: '对公账户凭证不能为空', trigger: 'blur' }],
                bankName: [{ required: true, message: '银行名称不能为空', trigger: 'blur' }],
                bankSubbranch: [{ required: true, message: '开户支行名称不能为空', trigger: 'blur' }],
                bankProvinceId: [{ required: true, message: '开户行省不能为空', trigger: 'blur' }],
                bankCityId: [{ required: true, message: '开户行市不能为空', trigger: 'blur' }],
                bankAreaId: [{ required: true, message: '开户行市不能为空', trigger: 'blur' }],
                bankTownId: [{ required: true, message: '开户行乡镇不能为空', trigger: 'blur' }],
                thirdStatus: [{ required: true, message: '支付审核状态不能为空', trigger: 'blur' }],
                alipayStatus: [{ required: true, message: '支付宝支付审核状态不能为空', trigger: 'blur' }],
                wxpayStatus: [{ required: true, message: '微信支付审核状态不能为空', trigger: 'blur' }],
                isSign: [{ required: true, message: '是否签名 0否 1是不能为空', trigger: 'blur' }],
                signPic: [{ required: true, message: '签名图片不能为空', trigger: 'blur' }],
                contractUrl: [{ required: true, message: '合同地址不能为空', trigger: 'blur' }],
                otherInfor: [{ required: true, message: '其他补充资料 如烟草经营许可证不能为空', trigger: 'blur' }],
            },

            provinceIdList: [], //省信息
            cityIdList: [], //市信息
            areaIdList: [], //区信息
            streetIdList: [],
            getCity: false,//区别是不是get来的
            getArea: false,//区别是不是get来的
            street: false,

            cityIdList2: [], //市信息
            areaIdList2: [], //区信息
            streetIdList2: [],
            getCity2: false,//区别是不是get来的
            getArea2: false,//区别是不是get来的
            street2: false,

            header: {
                token: localStorage.getItem('token')
            },
            action: UPLOAD_API + UPLOAD_PATH,

            retreatDialogVisible: false,
            auditId: '',
            applyRemarks: '',
            retreatRules: {
                desc: [{ required: true, message: '请填写拒绝原因', trigger: 'blur' }],
                incomeRatio: [{ required: true, message: '请填写门店收益比例', trigger: 'blur' }]
            },
            retreatForm: {
                resource: 3,
                desc: '',
                incomeRatio: ''
            },

            USER_code: USER,
            USER_search: USER_SEARCH,

            imageSrc: '',
        };
    },
    created() {
        this.getShopStoreOrgInfoList();
        this.getEnum();
        this.getAddress(1);
    },
    methods: {
        ShopStoreAudit(item) {
            console.log('applyRemarks', item);
            this.retreatDialogVisible = true;
            this.auditId = item.store.id;
            this.applyRemarks = item.store.remarks;
            this.retreatForm.desc = '';
        },
        resetStatus(id,sign){
            this.$confirm('确认重置吗？', '提示', {
                type: 'warning'
            }).then(() => {
                this.fullscreenLoading = true;
                get('/shop/storeorginfo/resetStatus',{id:id,sign:sign}).then((res)=>{
                    this.$confirm(res.msg, '提示', {type:'warning',showCancelButton: false})
                    this.fullscreenLoading = false;
                    this.getShopStoreOrgInfoList();
                })
            }).catch(() => {
            });

        },
        getImage(url){
            this.imageSrc = url;
            this.srcList[0] = url;
            this.$refs.images.showViewer = true;
        },
        // 审核取消按钮
        handleCloseRetreat() {
            this.retreatDialogVisible = false;
            this.auditId = '';//关闭后清除点击的id
            this.applyRemarks = ''; //关闭后清除申请人的说明
            this.retreatForm.resource = 3;//关闭后把选择的按钮置空
            this.retreatForm.desc = '';
            this.retreatForm.incomeRatio = '';
            console.log(this.retreatForm)
        },
        getSearchValueUser(val){
            this.queryForm.userId = val;
        },
        //审核确认按钮
        retreatSuccess(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    //处理选择同意&拒绝
                    this.retreatDialogVisible = false;
                    get(`/shop/store/auditStore`, {
                        id: this.auditId,
                        status: this.retreatForm.resource,
                        refuseReason: this.retreatForm.desc,
                        incomeRatio: this.retreatForm.incomeRatio
                    }).then((res) => {
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.handleCloseRetreat();
                            this.getShopStoreOrgInfoList();
                        }else{
                            this.$message({
                                message: res.msg,
                                type: 'error',
                                duration: 2000
                            });
                        }
                    });
                }
            });
        },
        // 获取对应地址
        getAddress(type, id=null) {
            get("/mpp/utils/findAreaList",{areaType:type,pid:id}).then((res)=>{
                if(res.success){
                    let array = []
                    for (let listElement of res.list) {
                        listElement.id = String(listElement.id)
                        array.push(listElement)
                    }
                    if(type == 1){
                        this.provinceIdList = array
                    }else if(type == 2){
                        this.cityIdList = array
                    }else if(type == 3){
                        this.areaIdList = array
                    }else if(type == 4){
                        this.streetIdList = array
                    }
                }
            })
        },
        // 获取对应地址
        getAddress2(type, id=null) {
            get("/mpp/utils/findAreaList",{areaType:type,pid:id}).then((res)=>{
                if(res.success){
                    let array = []
                    for (let listElement of res.list) {
                        listElement.id = String(listElement.id)
                        array.push(listElement)
                    }
                    if(type == 2){
                        this.cityIdList2 = array
                    }else if(type == 3){
                        this.areaIdList2 = array
                    }else if(type == 4){
                        this.streetIdList2 = array
                    }
                }
            })
        },
        beforeImageUpload(file) {
            const isLt2M = file.size / 1024 / 1024 < 50;
            if (!isLt2M) {
                this.$message.error('上传图片大小不能超过 50MB!');
            }
            return isLt2M;
        },
        // 进件
        //上传缩略图
        uploadImage11(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.shopStoreOrginfo.signPic = res.url;
                }
            });
        },
        uploadImage12(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.shopStoreOrginfo.contractUrl = res.url;
                }
            });
        },
        uploadImage21(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.shopStoreOrginfo.licensePic = res.url;
                }
            });
        },
        uploadImage31(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.shopStoreOrginfo.idCardFacade = res.url;
                }
            });
        },
        uploadImage32(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.shopStoreOrginfo.idCardBack = res.url;
                }
            });
        },
        uploadImage41(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.shopStoreOrginfo.bankCardFacade = res.url;
                }
            });
        },
        uploadImage42(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.shopStoreOrginfo.bankCardBack = res.url;
                }
            });
        },
        uploadImage43(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.shopStoreOrginfo.bankAccountVoucher = res.url;
                }
            });
        },
        uploadImage51(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.shopStoreOrginfo.wxpayApplyQrcode = res.url;
                }
            });
        },
        uploadImage52(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.shopStoreOrginfo.wxpayConfirmQrcode = res.url;
                }
            });
        },
        uploadImage53(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.shopStoreOrginfo.alipayApplyQrcode = res.url;
                }
            });
        },
        uploadImage54(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.shopStoreOrginfo.alipayConfirmQrcode = res.url;
                }
            });
        },


        search() {
            this.isSearch = !this.isSearch;
        },
        resetShopStoreOrgInfoList() {
            this.pageSize = 10;
            this.currentPage = 1;
            this.shopStoreOrginfoList = [];
        },
        resetDialog() {
            this.shopStoreOrginfoState = 'add';
            this.showDialog = false;
            this.queryForm = {
                userId: '', //用户id
                storeId: '', //门店id
                subAccount: '', //子商户号
                orgType: '', //组织类型 1小微 2企业 3个体
                licensePic: '', //营业执照图片
                licenseProvinceId: '', //营业执照省
                licenseCityId: '', //营业执照市
                licenseAreaId: '', //营业执照区
                licenseTownId: '', //营业执照乡镇
                licenseName: '', //营业执照名称
                licenseAddress: '', //营业执照地址
                licenseNumber: '', //社会统一信用代码
                licenseStartTime: '', //营业执照有效开始日期
                licenseEndTime: '', //营业执照有效结束日期
                licenseRange: '', //营业执照经营范围
                personName: '', //法人姓名
                personMobile: '', //法人手机号
                idCard: '', //身份证号
                idCardStartTime: '', //身份证有效开始日期
                idCardEndTime: '', //身份证有效结束日期
                idCardFacade: '', //身份证正面图片
                idCardBack: '', //身份证背面图片
                idCardAddress: '', //身份证地址
                bankAccount: '', //银行账号
                bankHolder: '', //银行卡持有人
                bankMobile: '', //银行预留手机号
                bankCardFacade: '', //银行卡正面图片
                bankCardBack: '', //银行卡背面图片
                bankAccountVoucher: '', //对公账户凭证
                bankName: '', //银行名称
                bankSubbranch: '', //开户支行名称
                bankProvinceId: '', //开户行省
                bankCityId: '', //开户行市
                bankAreaId: '', //开户行市
                bankTownId: '', //开户行乡镇
                thirdStatus: '', //支付审核状态
                alipayStatus: '', //支付宝支付审核状态
                wxpayStatus: '', //微信支付审核状态
                resultMsg: '', //响应报文
                isSign: '', //是否签名 0否 1是
                signPic: '', //签名图片
                contractUrl: '', //合同地址
                otherInfor: '', //其他补充资料 如烟草经营许可证
            };
            this.getShopStoreOrgInfoList();
        },
        resetDialogEdit() {
            this.shopStoreOrginfoState = 'add';
            this.showDialog = false;
            this.getShopStoreOrgInfoList();
        },
        closeDialog() {
            this.showDialog = false;
            this.shopStoreOrginfo = {
                userId: '', //用户id
                storeId: '', //门店id
                subAccount: '', //子商户号
                orgType: '', //组织类型 1小微 2企业 3个体
                licensePic: '', //营业执照图片
                licenseProvinceId: '', //营业执照省
                licenseCityId: '', //营业执照市
                licenseAreaId: '', //营业执照区
                licenseTownId: '', //营业执照乡镇
                licenseName: '', //营业执照名称
                licenseAddress: '', //营业执照地址
                licenseNumber: '', //社会统一信用代码
                licenseStartTime: '', //营业执照有效开始日期
                licenseEndTime: '', //营业执照有效结束日期
                licenseRange: '', //营业执照经营范围
                personName: '', //法人姓名
                personMobile: '', //法人手机号
                idCard: '', //身份证号
                idCardStartTime: '', //身份证有效开始日期
                idCardEndTime: '', //身份证有效结束日期
                idCardFacade: '', //身份证正面图片
                idCardBack: '', //身份证背面图片
                idCardAddress: '', //身份证地址
                bankAccount: '', //银行账号
                bankHolder: '', //银行卡持有人
                bankMobile: '', //银行预留手机号
                bankCardFacade: '', //银行卡正面图片
                bankCardBack: '', //银行卡背面图片
                bankAccountVoucher: '', //对公账户凭证
                bankName: '', //银行名称
                bankSubbranch: '', //开户支行名称
                bankProvinceId: '', //开户行省
                bankCityId: '', //开户行市
                bankAreaId: '', //开户行市
                bankTownId: '', //开户行乡镇
                thirdStatus: '', //支付审核状态
                alipayStatus: '', //支付宝支付审核状态
                wxpayStatus: '', //微信支付审核状态
                resultMsg: '', //响应报文
                isSign: '', //是否签名 0否 1是
                signPic: '', //签名图片
                contractUrl: '', //合同地址
                otherInfor: '', //其他补充资料 如烟草经营许可证
                wxpayNo: '',
                wxpayNo1: '',
                alipayNo: '',
                alipayNo1: '',
                wxpayApplyQrcode: '',
                wxpayConfirmQrcode: '',
                alipayApplyQrcode: '',
                alipayConfirmQrcode: '',
            };
        },
        submitForm() {
            delete this.shopStoreOrginfo.licenseProvince
            delete this.shopStoreOrginfo.licenseCity
            delete this.shopStoreOrginfo.licenseArea
            delete this.shopStoreOrginfo.licenseTown
            delete this.shopStoreOrginfo.bankProvince
            delete this.shopStoreOrginfo.bankCity
            delete this.shopStoreOrginfo.bankArea
            delete this.shopStoreOrginfo.bankTown
            delete this.shopStoreOrginfo.store
            delete this.shopStoreOrginfo.user

            if (this.shopStoreOrginfoState == 'add') {
                this.$refs.shopStoreOrginfoForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        post(`/shop/storeorginfo/add`, { ...this.shopStoreOrginfo }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetShopStoreOrgInfoList();
                                this.resetDialog();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    }
                });
            } else if (this.shopStoreOrginfoState == 'edit') {
                this.$refs.shopStoreOrginfoForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        post(`/shop/storeorginfo/edit`, { ...this.shopStoreOrginfo }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                // this.resetShopStoreOrgInfoList();
                                this.resetDialogEdit();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    }
                });
            }
        },
        addShopStoreOrgInfo() {
            this.showDialog = true;
            this.shopStoreOrginfoState = 'add';
        },
        checkShopStoreOrgInfo(shopStoreOrginfoId) {
            console.log(shopStoreOrginfoId);
            this.currentShopStoreOrgInfoId = shopStoreOrginfoId;

            this.getShopStoreOrgInfoById();
            this.showDialog = true;
            this.shopStoreOrginfoState = 'check';
        },
        editShopStoreOrgInfo(shopStoreOrginfoId) {
            console.log('shopStoreOrginfo', shopStoreOrginfoId);
            if (shopStoreOrginfoId) {
                this.currentShopStoreOrgInfoId = shopStoreOrginfoId;
                this.getShopStoreOrgInfoById();
            } else {
                this.shopStoreOrginfo = { ...this.shopStoreOrginfo, ...this.multipleSelection[0] };
            }

            this.showDialog = true;
            this.shopStoreOrginfoState = 'edit';
        },
        deleteShopStoreOrgInfo(shopStoreOrginfoId) {
            let ids = '';
            if (shopStoreOrginfoId) {
                ids = shopStoreOrginfoId;
            } else {
                ids = this.multipleSelection.map((shopStoreOrginfo) => shopStoreOrginfo.id).join(',');
            }
            console.log({ ids });
            this.$confirm('确定删除所选项吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    deleteFun(`/shop/storeorginfo/delete`, { ids }).then((res) => {
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.resetShopStoreOrgInfoList();
                            this.getShopStoreOrgInfoList();
                        } else {
                            this.$message({
                                message: res.msg,
                                type: 'error',
                                duration: 2000
                            });
                        }
                    });
                })
                .catch(() => {
                });
        },
        refreshShopStoreOrgInfoList() {
            this.resetShopStoreOrgInfoList();
            this.getShopStoreOrgInfoList();
        },
        getShopStoreOrgInfoList(query = {}) {
            this.loading = true;
            get(`/shop/storeorginfo/findList`, {
                ...this.queryForm,
                pageNum: this.currentPage,
                pageSize: this.pageSize
            }).then((res) => {
                this.loading = false;
                if (res.success) {
                    this.shopStoreOrginfoList = res.page.list;
                    this.totalNum = res.page.total;
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            });
        },
        getShopStoreOrgInfoById() {
            get(`/shop/storeorginfo/get`, { id: this.currentShopStoreOrgInfoId }).then((res) => {
                if (res.success) {
                    this.shopStoreOrginfo = { ...this.shopStoreOrginfo, ...res.shopStoreOrginfo };
                    this.getCity = true;
                    this.getArea = true;
                    this.street = true;
                    this.getCity2 = true;
                    this.getArea2 = true;
                    this.street2 = true;
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            });
        },
        /**
         * 导出信息
         */
        exportShopStoreOrgInfoList() {
            //this.btnLoading = true;
            exprotExcel(`/shop/storeorginfo/export`, { ...this.queryForm });
        },
        /**
         * 导出模板
         */
        importTemplate() {
            this.btnLoading = true;
            importTemplate(`/shop/storeorginfo/importTemplate`, this.btnLoading);
        },
        /**
         * 导入数据
         */
        isImport() {
            this.isImportDate = !this.isImportDate;
        },
        upload(params) {
            const file = params.file;
            const formData = new FormData();
            formData.append('file', file);
            console.log({ formData });
            importDate(`/shop/storeorginfo/importData`, formData);
            this.refreshShopStoreOrgInfoList();
        },
        handleSelectionChange(value) {
            console.log(value);
            this.multipleSelection = value;
        },
        currentChange(page) {
            this.currentPage = page;
            this.getShopStoreOrgInfoList();
        },
        sizeChange(size) {
            this.pageSize = size;
            this.getShopStoreOrgInfoList();
        },

        // 大图预览
        updateSrcList(src) {
            this.srcList[0] = src
        },

        // 获取枚举
        getEnum(){
            get('/shop/utils/getEnum',{
                enumType: "store_org_type_status"
            }).then((res)=>{
                if(res.success){
                    this.storeOrgTypeStatusEunmList = res.enumList;
                }
            })

            get('/mpp/utils/getEnum',{
                enumType: "yes_no"
            }).then((res)=>{
                if(res.success){
                    this.yesNoEunmList = res.enumList;
                }
            })

            get('/mpp/utils/getEnum', {
                enumType: 'audit_status'
            }).then((res) => {
                if(res.success){
                    this.auditStatusEnumList = res.enumList;
                }
            });
        },

        // 计算AuditStatus
        computeAuditStatus(type) {
            for (let i = 0; i < this.auditStatusEnumList.length; i++) {
                if (this.auditStatusEnumList[i].key == type) {
                    return this.auditStatusEnumList[i].value;
                }
            }
        },

        // 提交进件
        onRegister(storeId){
            this.$confirm('确认资料核对无误', '提示', {
                type: 'warning'
            }).then(() => {
                this.fullscreenLoading = true;
                get('/shop/store/submitStoreOrgInfo',{
                    storeId
                }).then((res)=>{
                    this.$confirm(res.msg, '提示', {type:'warning',showCancelButton: false})
                    this.fullscreenLoading = false;
                })
            }).catch(() => {
            });
        },

        // 微信认证
        wxReport(storeId){
            this.$confirm('确认要进行微信认证吗?', '提示', {
                type: 'warning'
            }).then(() => {
                this.fullscreenLoading = true;
                get('/shop/store/wxReport',{
                    storeId
                }).then((res)=>{
                    this.$confirm(res.msg, '提示', {type:'warning',showCancelButton: false})
                    this.fullscreenLoading = false;
                })

            }).catch(() => {
            });
        },

        // 支付宝认证
        aliReport(storeId){
            this.$confirm('确认要进行支付宝认证吗?', '提示', {
                type: 'warning'
            }).then(() => {
                this.fullscreenLoading = true;
                get('/shop/store/aliReport',{
                    storeId
                }).then((res)=>{
                    this.$confirm(res.msg, '提示', {type:'warning',showCancelButton: false})
                    this.fullscreenLoading = false;
                })

            }).catch(() => {
            });
        },

        // 申请报备
        reportBei(storeId){
            this.$confirm('确认要进行报备吗?', '提示', {
                type: 'warning'
            }).then(() => {
                this.fullscreenLoading = true;
                get('/shop/store/reportBei',{
                    storeId
                }).then((res)=>{
                    this.$confirm(res.msg, '提示', {type:'warning',showCancelButton: false})
                    this.fullscreenLoading = false;
                })

            }).catch(() => {
            });
        }
    }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
    padding: 15px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    button {
        display: flex;
        align-items: center;
        justify-content: center;
    }
}

.avatar {
    width: 130px;
    height: 130px;
    display: block;
}

::v-deep .el-upload--text {
    width: 130px;
    height: 130px;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

::v-deep .el-range-separator {
    width: 20px;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 130px;
    height: 130px;
    line-height: 130px;
    text-align: center;
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}


.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}

.flex{
    display: flex;
    align-items: center;
    justify-content: center;
}
.active{
    color:#67C23A;
}
</style>